import { ArrowTopRightOnSquareIcon } from "@heroicons/react/24/outline";
import { Link } from "react-router-dom";

import { Modal } from "../../../components/ui/Modal";
import useUser from "../../../hooks/useUser";
import EditOffer from "../pages/List/components/EditOffer";

/**
 * Contact name on an offers table row: the name edits the offer and the icon
 * opens the contact in a new tab.
 *
 * @param {object} props.values - the offer row
 * @param {number} props.artworkId - artwork the offers table belongs to
 */
const OfferContactCell = (props = {}) => {
  const { values, artworkId } = props;
  const { hasPermission } = useUser();
  const contact = values?.contact;
  const contactName = contact?.name || contact?.id;

  const modalProps = {
    body: EditOffer,
    closeOnBackdrop: false,
    hideCloseButton: false,
    scale: "lg",
    offer: { artworkId, ...values },
  };

  return (
    <div className="flex items-center gap-2">
      {hasPermission("UPDATE_OFFER") ? (
        <Modal {...modalProps}>
          <button type="button" className="underline" title="Edit Offer">
            {contactName}
          </button>
        </Modal>
      ) : (
        <span>{contactName}</span>
      )}
      {contact?.id && (
        <Link
          to={`/contacts/${contact.id}/details`}
          target="_blank"
          rel="noopener noreferrer"
          title="Open contact in a new tab"
          aria-label="Open contact in a new tab"
        >
          <ArrowTopRightOnSquareIcon className="h-4 w-4 text-gray-400 hover:text-black" />
        </Link>
      )}
    </div>
  );
};

export default OfferContactCell;
